import type {DefaultMantineColor} from '@mantine/core';
import type {IStateMachine} from 'src/types/StateMachine';

// Structurally identical to design/atoms/Pill's PillProps — declared
// locally because src/shared sits below the design tier and may not
// import from it.
interface StatePill {
  text: string;
  color?: DefaultMantineColor;
}

/**
 * @registry Maps a state machine status ID to its pill text/color for display.
 */
export const GetStatePillFromStateMachine = (
  status?: number,
  machine?: IStateMachine
): StatePill[] => {
  if (!machine || !status) {
    return [];
  }

  return machine.states
    .filter(s => s.id === status)
    .map(s => {
      return {text: s.title, color: s.color};
    });
};
